import { RefObject, useEffect } from 'react';

import { ScrollView, View } from 'react-native';

import { scrollToTargetInScrollView } from 'utils/scroll/scroll-to-target-in-scroll-view';

export const useScrollToHighlightedRow = (
  scrollViewRef: RefObject<ScrollView | null> | undefined,
  rowRefs: RefObject<Record<string, View | null>>,
  highlightedRowId?: string
) => {
  useEffect(() => {
    if (!highlightedRowId || !scrollViewRef?.current) {
      return;
    }

    const frame = requestAnimationFrame(() => {
      const target = rowRefs.current[highlightedRowId];
      const scrollView = scrollViewRef.current;
      if (!target || !scrollView) {
        return;
      }
      scrollToTargetInScrollView(scrollView, target);
    });

    return () => cancelAnimationFrame(frame);
  }, [highlightedRowId, rowRefs, scrollViewRef]);
};
